import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import ModuleHead from '../../components/moduleHead';
import ModuleFeed from '../../components/moduleFeed';

class Hotspots extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { hotspotsHead, hotspotsData } = this.props.content;

        return (
            <div className={styles.hotspots}>
                <Chip id="260640" type="struct" title="操作热点标题" groupName="放眼全球" content={hotspotsHead}>
                    <ModuleHead />
                </Chip>
                <div className={styles.hotspotsList}>
                    {hotspotsData.map((item, index) => {
                        return (
                            <a href={item.url} key={index} target="_blank" className={styles.hotspotsItem}>
                                {item.title}
                            </a>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Hotspots);
